import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToLocation() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    requestAnimationFrame(() => {
      if (!hash || hash === '#') {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        return;
      }

      const target = document.getElementById(hash.slice(1));

      if (target) {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        target.focus({ preventScroll: true });
      }
    });
  }, [pathname, hash]);

  return null;
}
